import { Form, Input } from 'antd'
import { FC } from 'react'
import getNumberOfLabelsInFlood from '../../../../../../../../../../helpers/fields-calculation/stamps/get-number-of-labels-in-flood'
import useWatch from '../../../hooks/form/use-watch'
import { useGetRollersQuery } from '../../../../../../../../../../store/api/rollers-api'

interface NumberOfLabelsInFloodProps {}

const NumberOfLabelsInFlood: FC<NumberOfLabelsInFloodProps> = () => {
    const { data } = useGetRollersQuery()
    const rollerDocId = useWatch('roller')
    const range = useWatch('range')
    const length = useWatch('length')
    const roller = data?.data.find(({ documentId }) => documentId === rollerDocId)

    return (
        <Form.Item label={'Кол-во этикеток в 1 р.'}>
            <Input
                value={getNumberOfLabelsInFlood({ roller: roller?.roller || 0, range, length })}
                disabled
            />
        </Form.Item>
        // TODO: тут надо сделать группу с вып списком выбора кол-во шт или размер толщины мм, у всех разные этикераторы
    )
}

export default NumberOfLabelsInFlood
